import ProblemMain from "../../components/ProblemMain";
import problemKendaraanTradoConfig from "../utils/problemKendaraanTradoConfig";

const problemKendaraanTradoVariant = { config: problemKendaraanTradoConfig };

const ProblemKendaraanTradoMain = () => {
  return <ProblemMain variant={problemKendaraanTradoVariant} />;
};

export default ProblemKendaraanTradoMain;
